<template>
  <div class="event-lots">
    <step-title
      title="Ingressos"
      description="Visualize e configure os ingressos do seu evento."
      class="mb-6"
    />

    <bp-table-header
      class="mb-6"
      :total="pagination.count"
      @refresh="refresh"
      @open-filter="filterModal = true"
    >
      <template #input>
        <bp-input
          v-model="filters.search"
          size="md"
          placeholder="Buscar..."
          :delay="300"
          @change="refresh"
        />
      </template>

      <template #filter>
        <responsive-modal
          v-model="filterModal"
          title="Filtrar"
          subtitle="Selecione os filtros e aplique"
        >
          <lots-filter
            v-model="filters"
            @input="refresh"
            @close="filterModal = false"
          />
        </responsive-modal>
      </template>

      <template #buttons>
        <bp-button
          size="md"
          label="Novo ingresso"
          icon="fa fa-plus"
          :route="{ name: 'event-new-lot', params: { id: $route.params.id } }"
        />
      </template>
    </bp-table-header>

    <div class="text-center my-9" v-if="loading">
      <b-spinner variant="primary" />
    </div>

    <template v-else>
      <bp-data-table
        :data="lots"
        :columns="columns"
        empty-message="Você ainda não cadastrou nenhum ingresso!"
      />

      <div class="d-flex justify-content-end mt-5">
        <bp-paginator
          v-model="page"
          :pagination="pagination"
          @change-page="dispatch"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { formatMoney } from "@/functions/helpers";
import { mapState } from "vuex";
import LotsFilter from "@/components/product/events/LotsFilter.vue";

export default {
  components: { LotsFilter },
  data() {
    return {
      filterModal: false,
      filters: {
        status: "",
        search: ""
      },
      loading: false,
      page: 1
    };
  },
  computed: {
    ...mapState("events", ["lots", "pagination"]),
    columns() {
      return [
        { name: "Nome", default: "-", field: "name" },
        {
          name: "Total Vendidos",
          field: "total_sales",
          size: "0.7fr",
          transform: (v, item) => `${v}/${item.stock}`
        },
        {
          name: "Valor",
          size: "0.5fr",
          field: "price",
          transform: v => `R$ ${formatMoney(v)}`
        },
        {
          name: "Link",
          field: "url",
          type: "link",
          size: "0.5fr"
        },
        {
          name: "Status",
          field: "status",
          size: "0.5fr",
          class: v => (v == "enabled" ? "active-badge" : "inactive-badge"),
          transform: v => (v == "enabled" ? "Ativo" : "Inativo")
        },
        {
          name: "",
          type: "menu",
          options: item => [
            {
              label: "Editar",
              icon: "fa-regular fa-pen",
              click: item => {
                this.$router.push({
                  name: "event-edit-lot",
                  params: {
                    id: this.$route.params.id,
                    lot_code: item.code
                  }
                });
              }
            },
            ...(item.status == "enabled"
              ? [
                  {
                    label: "Desativar ingresso",
                    icon: "fa fa-ban",
                    color: "negative",
                    click: this.changeStatus,
                    dialog: {
                      secondary: true,
                      text: "Tem certeza que quer desativar esse ingresso?",
                      secondaryButtonText: "Desativar ingresso",
                      variant: "negative",
                      buttonText: "Cancelar",
                      icon: "fa-regular fa-ban",
                      secondaryAction: this.changeStatus
                    }
                  }
                ]
              : [
                  {
                    label: "Ativar ingresso",
                    icon: "fa fa-check",
                    color: "positive",
                    click: this.changeStatus
                  }
                ])
          ]
        }
      ];
    }
  },
  methods: {
    changeStatus(item) {
      const status = item.status === "enabled" ? "canceled" : "enabled";

      this.$store
        .dispatch("events/editLot", { code: item.code, status })
        .then(() => {
          this.$message.success("Status atualizado");
          this.refresh();
        })
        .catch(() => this.$message.error("Erro ao atualizar status"));
    },
    refresh() {
      this.page = 1;
      this.dispatch();
    },
    dispatch(offset = 0) {
      this.loading = true;
      this.$store
        .dispatch("events/getLots", {
          product_id: this.$route.params.id,
          ...this.filters,
          offset
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  mounted() {
    this.dispatch();
  }
};
</script>
